import React from 'react';
import { Box, TextField, InputAdornment } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

interface TableToolbarProps {
  searchQuery: string;
  onSearch: (query: string) => void;
}

export const TableToolbar: React.FC<TableToolbarProps> = ({
  searchQuery,
  onSearch
}) => {
  return (
    <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
      <TextField
        fullWidth
        placeholder="Search students by name, ID, or grade..."
        value={searchQuery}
        onChange={(e) => onSearch(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" />
            </InputAdornment>
          )
        }}
        size="small"
      />
    </Box>
  );
};